import React, { useEffect, useState } from 'react';
import ecobg from '../../../assets/ecobg.png';
import Heading from '../../Components/Heading';
import { Box, Button, Container, Grid } from '@mui/material';
import styled from '@emotion/styled';
import Paragraph from '../../Components/Paragraph';
import dvpn from '../../../assets/dvpn.png';
import SubHeading from '../../Components/SubHeading';
import PurpleButton from '../../Components/PurpleButton';
import layerbg from '../../../assets/layerbg.png';
import bgtunnel from '../../../assets/bgtunnel.png';
import bgtalk from '../../../assets/bgtalk.png';
import surf from '../../../assets/surf.png';
import sunshine from '../../../assets/sunshine.png';
import star from '../../../assets/star.mp4';
import nologtwo from '../../../assets/nologtwo.png';
import nodetwo from '../../../assets/nodestwo.png';
import nodecard from '../../../assets/nodecard.png';
import cryptopyament from '../../../assets/cryptopyament.png';
import cardbox2 from '../../../assets/cardbox2.png';
import Aos from 'aos';
import ubantu from  '../../../assets/U.png'  
import andoid from  '../../../assets/A.png'  
import ios from  '../../../assets/I.png'   
import macos from  '../../../assets/M.png'   
import window from  '../../../assets/W.png' 

const LayerImage = styled.img`
    position: absolute;
    top: -600px;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover; 
    pointer-events: none; 
    z-index: 1;
    @media (max-width: 600px) {
    display: none;
  }
`;

const Wrapper = styled(Box)`
  padding: 140px 0px;
  justify-content: center;
  text-align: center;
  position: relative;
     @media (max-width: 600px) {
     padding: 80px 0px;
  }
`;

const CardBox = styled(Box)`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  z-index: 9;
`;

const CardBox1 = styled(Box)`
    position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 100px !important;
  height: 100%;
  z-index: 9;
`;
const CardBox2 = styled(Box)`
    position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 20px !important;
  height: 100%;
  z-index: 9;

  @media (max-width: 600px) {
    background: #070616;
    border-radius: 16px;
    overflow: hidden;
  }
`;

const ImageContainer = styled(Box)`
  position: relative;
  width: 100%;
  /* height: clamp(300px, 35vw, 680px); */
  border-radius: 16px;
  overflow: hidden;
  flex-shrink: 0;
  
 
  @media (max-width: 1200px) {
    height: clamp(280px, 90vw, 550px);  /* was 350px fixed, now responsive */
  }
   @media (max-width: 600px) {
    height: clamp(280px, 90vw, 420px);  /* was 350px fixed, now responsive */
  }
   @media (max-width: 350px) {
    height: clamp(280px, 100vw, 420px);  /* was 350px fixed, now responsive */
  }
`;
const ImageContainer2= styled(Box)`
  position: relative;
  width: 100%;
  height: clamp(300px, 35vw, 680px);
  border-radius: 16px;
  overflow: hidden;
  flex-shrink: 0;
  @media (max-width: 1200px) {
    height: clamp(280px, 90vw, 420px);  
  }
  @media (max-width: 600px) {
    height: 560px;
    background: #070616;

    img {
      /* object-fit: contain; */
      object-position: center bottom;
    }
  }
    @media (max-width: 350px) {
    height: 540px;  
  }
`;

const CardImage = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
  /* removed object-fit: none on mobile — that was causing the stretch */
`;

const CardImage1 = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: cover;   
  transition: transform 0.3s ease;
  /* removed object-fit: none on mobile */
`;
const CardContent = styled(Box)`
  position: absolute;
  top: 40px;
  left: 40px;
  text-align: left;
  color: #fff;
  max-width: 630px;

  @media (max-width: 1065px) {
    top: 12px;
    left: 16px;
    max-width: 90%;
  }
     @media (max-width: 1060px) {
    top: 25px;
    left: 25px;
    max-width: 90%;
  }
  @media (max-width: 600px) {
    top: 8px;
    left: 12px;
  }
`;
const CardContent2 = styled(Box)`
  position: absolute;
  top: 40px;
  left: 40px;
  text-align: left;
  color: #fff;
  max-width: 630px;

  @media (max-width: 1065px) {
    top: 12px;
    left: 16px;
    max-width: 90%;
  }
     @media (max-width: 1060px) {
    top: 25px;
    left: 25px;
    max-width: 90%;
  }
  @media (max-width: 600px) {
    top: 21px;
    left: 12px;
  }
`;

const CardContent1 = styled(Box)`
  position: absolute;
  top: 40px;
  left: 44px;
  text-align: left;
  color: #fff;
  max-width: 630px;

  @media (max-width: 1065px) {
    top: 12px;
    left: 16px;
    max-width: 90%;
  }
   @media (max-width: 1060px) {
    top: 32px;
    left: 36px;
    max-width: 90%;
  }


  @media (max-width: 600px) {
    top: 21px;
    left: 12px;
  }
`;
const CardContent3 = styled(Box)`
  position: absolute;
  top: 40px;
  right: 120px;
  text-align: left;
  color: #fff;
  max-width: 630px;

  @media (max-width: 1065px) {
    top: 12px;
    left: 16px;
    /* max-width: 90%; */
  }
   @media (max-width: 1060px) {
    top: 32px;
    left: 36px;
    /* max-width: 90%; */
  }


  @media (max-width: 600px) {
    top: 24px;
    left: 20px;
    right: 20px;
    max-width: calc(100% - 40px);
    z-index: 2;
  }
`;

const StyledSubHeading = styled(SubHeading)`
  color: #ffffff;
  margin-bottom: 25px;
  font-size: 48px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);

  @media (max-width: 1065px) {
    font-size: 32px;
  }

  @media (max-width: 768px) {
    font-size: 28px;
  }

  @media (max-width: 600px) {
    font-size: 24px;
    margin-bottom: 10px;
  }
`;

const StyledParagraph = styled(Paragraph)`
  color: #ffffff;
  margin-bottom: 20px;
  font-size: 18px;
  max-width: 550px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);

  @media (max-width: 1065px) {
    font-size: 16px;
    max-width: 90%;
  }

  @media (max-width: 768px) {
    font-size: 15px;
  }

  @media (max-width: 600px) {
    font-size: 14px;
    margin-bottom: 16px;
  }
`;

const BlackButton = styled(Button)`
text-transform: none;
color: white;
font-family: "PoppinsM";
width: fit-content;
border-radius: 40px !important;
font-size:14px;
font-family: Bold !important;
padding:${(props) => (props.p ? props.p : "2px 10px")};
border: 3px solid #000000f0;

&:hover{
  color: white;
}
@media(max-width: 599px){
font-size: 14px !important;
padding: 7px 9px !important;
    }
`;

const UpperBox = styled(Box)`
background: linear-gradient(39deg,#43404d 10%,#8d8994); 
padding: 2px;
border-radius: 40px;
width: max-content;
`;

const EarthBox = styled(Box)`
position: relative;
border-radius: 24px;
overflow: hidden;
display: flex;
height: 150vh;
flex-direction: column;
align-items: center;
justify-content: center;
`;

const TextBox = styled(Box)`
  position: absolute;
  bottom: 23%;
  text-align: center;
  z-index: 2;
  width: 100%;
  @media(max-width: 599px){
  bottom: 24%;
    }
`;

const FontParagraph = styled(Paragraph)`
 font-family: SemiBold !important;
  font-size: 28px;
  margin-top: 130px;
  @media(max-width: 1100px){
      margin-top: 80px;
  font-size: 23px;
    }
 @media(max-width: 599px){
  font-size: 26px;
  margin-top: 120px;
    }
`;

const BottomBox = styled(Box)`
  position: relative;
  width: 100%;
  z-index: 2; 
  margin-top: -300px;
  @media(max-width: 1550px){
   margin-top: -250px;
    }
`;

const BlurOverlay = styled(Box)`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 140%;
  background: linear-gradient(
    to bottom,
    rgba(245, 245, 255, 0) 0%,    
    rgba(0, 0, 0, 0.25) 50%,
    #000000f0 100%
  );
  z-index: -1; 
`;

// Updated ImageWrapperBox with very small border width
const ImageWrapperBox = styled(Box)`
  position: relative;
  width: 100%;
  min-height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  overflow: hidden;
  border-radius: 20px;
  cursor: pointer;
  background: #070616;
  border: 0.5px solid #222;
  
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  box-shadow: 
    0 2px 3px 0 #FFF inset,
    0 0 116.1px -53px #7300FF inset,
    0 41px 66.9px -33px #CB60FA inset,
    0 4px 20px rgba(0, 0, 0, 0.3), !important;
    
 animation: smoothMovingShadow 3s ease-in-out infinite !important; 
  &:hover {
   
    transform: translateY(-8px);
    box-shadow: 
      0 2px 2px 0 #FFF inset,
      0 0 116.1px -53px #7300FF inset,
      0 41px 66.9px -33px #CB60FA inset,
      0 15px 40px rgba(115, 0, 255, 0.4),
      0 8px 25px rgba(203, 96, 250, 0.3);
  }

  @keyframes smoothMovingShadow {
    0% {
      box-shadow: 
        0 2px 2px 0 #FFF inset,
        0 0 116.1px -53px #7300FF inset,
        0 41px 66.9px -33px #CB60FA inset,
        0 15px 40px rgba(115, 0, 255, 0.4),
        0 8px 25px rgba(203, 96, 250, 0.3);
    }
    25% {
      box-shadow: 
        1px 0 2px 0 #FFF inset,
        0 0 116.1px -53px #7300FF inset,
        0 41px 66.9px -33px #CB60FA inset,
        0 15px 40px rgba(115, 0, 255, 0.4),
        0 8px 25px rgba(203, 96, 250, 0.3);
    }
    50% {
      box-shadow: 
        0 -2px 2px 0 #FFF inset,
        0 0 116.1px -53px #7300FF inset,
        0 41px 66.9px -33px #CB60FA inset,
        0 15px 40px rgba(115, 0, 255, 0.4),
        0 8px 25px rgba(203, 96, 250, 0.3);
    }
    75% {
      box-shadow: 
        -1px 0 2px 0 #FFF inset,
        0 0 116.1px -53px #7300FF inset,
        0 41px 66.9px -33px #CB60FA inset,
        0 15px 40px rgba(115, 0, 255, 0.4),
        0 8px 25px rgba(203, 96, 250, 0.3);
    }
    100% {
      box-shadow: 
        0 2px 2px 0 #FFF inset,
        0 0 116.1px -53px #7300FF inset,
        0 41px 66.9px -33px #CB60FA inset,
        0 15px 40px rgba(115, 0, 255, 0.4),
        0 8px 25px rgba(203, 96, 250, 0.3);
    }
  }
`;

const WrapperImage = styled('img')`
  width: auto;
  max-width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 16px;
  z-index: 2;
  margin-top: -100px;
  position: relative;
  transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
`;

const OverlayText = styled(FontParagraph)`
  position: absolute;
  z-index: 2;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  max-width: 75%;
  text-align: center;
  line-height: 1.3;
  white-space: pre-line;
  padding: 0 15px;
  @media(max-width: 599px){
    white-space: normal;
  }
   /* @media(max-width: 599px){
   margin-top: 25px !important;
    } */
`;

const EnhancedCardBox = styled(CardBox)`
  transition: transform 0.4s ease;


`;
const AnimatedCardWrapper = ({ children, imageSrc, overlayText }) => {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <ImageWrapperBox
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <WrapperImage
        src={imageSrc}
        alt={overlayText}
        style={{
          transform: isHovered ? 'scale(1.08)' : 'scale(1)'
        }}
      />
      <OverlayText style={{
        transform: isHovered ? 'translateY(-8px)' : 'translateY(0)',
        textShadow: isHovered ? '0 0 20px rgba(255, 255, 255, 0.6)' : 'none'
      }}>
        {overlayText}
      </OverlayText>
      {children}
    </ImageWrapperBox>
  );
};

const EcoSystem = () => {
    const [filterdButton,setFilterdButton] = useState([]);
  const [Ips , setIps] = useState([]);
  const [status , setStatus] = useState("loading");
  const main_array =  [ 
    //  {  
    //   name : "Linux", 
    //   w : "70%",  
    //   small_w : "62%",
    //   src  : linux,
    //   arr : [ 
    //     {
    //       title: "Linux (.AppImage)",
    //       link: 'https://shadownode.org/vpnexe/linux-2.0.0.AppImage',
    //       target:"blank"
    //     },
    //   ]
    //   }, 
      {  
        name : "Ubuntu", 
        w : "62px",  
        small_w : "39px",
        src  : ubantu,
        arr : [ 
          {
            title: "Ubuntu (.AppImage)",
            link: 'https://remote.shadownode.org/shadow_node_vpn_premium.deb',
            target:"blank"
          },
  
        ]
        }, 
        {  
          name : "Android", 
          w : "62px",  
          small_w : "39px",  
          src  : andoid,
          arr : [ 
            {
              title: 'Android TV',
              link: './shadow_node_android_tv.apk',
              target:"blank"
            },
            {
              title: 'Android (Premium)',
              link:'https://play.google.com/store/apps/details?id=com.shadownode.svpn',
              target:"blank"
            }, 
            {
              title: 'Android (Free)',
              link: 'https://play.google.com/store/apps/details?id=com.svpn.freeshadownode',
              target:"blank"
            },
          ]
          },
          {  
            name : "IOS", 
            w : "62px",  
            small_w : "39px",
            src  : ios,
            arr : [ 
              {
                title: 'IOS (Premium)',
                link:'https://apps.apple.com/pk/app/shadow-node-dvpn-lite/id6680189108',
                target:"blank"
              },
              {
                title: 'IOS (Free)',
                link:'https://apps.apple.com/pk/app/shadow-node-dvpn-lite/id6680189108',
                target:"blank"
              }, 
            ]
            }, 
            {  
              name : "Windows", 
              w : "62px",  
              small_w : "39px",
              src  : window,
              arr : [ 
                {
                  title:'Windows (Premium)',
                  link: 'https://remote.shadownode.org/window/Shadow-Node-VPN_Premium_Setup-1.0.0.exe',
                  target:"blank"
                },
                {
                  title: 'Windows (Free)',
                  link:'https://remote.shadownode.org/window/ShadowNodeVPN_Windows-free.exe',
                  target:"blank"
                }
              ]
              }, 
              {  
                name : "macOS", 
                w : "62px", 
                small_w : "39px", 
                src  : macos,
                arr : [ 
                  {
                    title: 'macOS(M1)',
                    link:'https://apps.apple.com/pk/app/shadow-node-dvpn-lite/id6680189108',
                    target:"blank"
                  },
                  {
                    title: 'macOS(M2)',
                    link: 'https://apps.apple.com/pk/app/shadow-node-dvpn-lite/id6680189108',
                    target:"blank"
                  }
                ]
                },  
   ]   

   const detectOS = () => { 

    const dataOS = [
      {
        string: navigator.platform,
        subString: 'Win',
        identity: 'Windows',
      },
      {
        string: navigator.platform,
        subString: 'Mac',
        identity: 'macOS',
      },
      {
        string: navigator.userAgent,
        subString: 'iPhone',
        identity: 'IOS',
      },
      {
        string: navigator.userAgent,
        subString: 'iPad',
        identity: 'IOS',
      },
      {
        string: navigator.userAgent,
        subString: 'iPod',
        identity: 'IOS',
      },
      {
        string: navigator.userAgent,
        subString: 'Android',
        identity: 'Android',
      },
      {
        string: navigator.platform,
        subString: 'Linux',
        identity: 'Linux',
      },
    ];
  
    for (let i = 0; i < dataOS.length; i++) {
      const dataString = dataOS[i].string;
      if (dataString.indexOf(dataOS[i].subString) !== -1) {
        return dataOS[i].identity;
      }
    }
    return 'Unknown OS';
  }; 


  useEffect(() => {
    const os = detectOS(); 
    // setO_sys(os);
    console.log("Operating System:", os); 
    const filterarray = main_array.filter((items) => items.name === os); 
    console.log("filterarray",filterarray);
    setFilterdButton(filterarray); 
    console.log("filterdButton",filterdButton);
  }, []);

useEffect(() => {
  const isMobile = window.innerWidth <= 600;

  Aos.init({
    duration: isMobile ? 800 : 2000, 
    offset: isMobile ? 50 : 100, 
    once: true,
    easing: isMobile ? 'ease-out' : 'ease-out-cubic',
    mirror: false,
    disable: false, 
  });

  Aos.refresh();

}, []);
const ImageContainerContain = styled(Box)`
  position: relative;
  width: 100%;
  height: clamp(300px, 35vw, 680px);
  border-radius: 16px;
  overflow: visible;          /* don't clip the image's own border radius */
  flex-shrink: 0;
  background: #0d0b1e;        /* fill the letterbox gaps */

  @media (max-width: 600px) {
    height: clamp(280px, 70vw, 420px);
  }
`;
  return (
    <Wrapper  id='shadowecosystem' >
      <LayerImage src={layerbg} alt="Layer Background" />
      <Container maxWidth="xl" >
        <Heading style={{ marginBottom: '20px' }}>
          Shadow Eco<span style={{
            background: "linear-gradient(160deg, rgb(197, 180, 226) 43%, rgb(168 96 255)) text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontWeight: 'Bolder'
          }}>system</span>
        </Heading>

        <Paragraph style={{ maxWidth: '900px', margin: '0 auto 40px auto' }}>
         Most privacy tools stop at secure browsing. Shadow Node extends far beyond that. SVPN is building the privacy infrastructure layer for Web3, connecting communication, browsing, and network access into one continuous ecosystem. Not separate tools. Not isolated applications. One unified privacy stack for the multichain internet.
        </Paragraph>

        {/* Main dVPN Card */}
        <CardBox1  >
          <ImageContainer>
            <CardImage1 src={dvpn} alt="Shadow Node dVPN" draggable='false' />
          </ImageContainer>
          <CardContent1>
            <StyledSubHeading>Shadow Node VPN</StyledSubHeading>
            <StyledParagraph>
             ShadowNode VPN delivers secure, high performance private access through encrypted routing and censorship resistant networking infrastructure. Built for users who value privacy, speed, and unrestricted connectivity, the VPN combines advanced protocol architecture with reliable global access powered by the ShadowNode ecosystem and SVPN.
            </StyledParagraph>
  {filterdButton.map((item) => ( 
                         <PurpleButton key={item.title} src={item.src} name={item.name} w={item.w} small_w={item.small_w} array={item.arr} style={{ padding: '7px 24px', fontSize: '16px' }}/>
               ))} 
     

          </CardContent1>
        </CardBox1>
        <CardBox2  >
          <ImageContainer2>
            <CardImage1 src={cardbox2} alt="Shadow Node dVPN" draggable='false' />
          </ImageContainer2>
          <CardContent3>
            <StyledSubHeading>Shadow Tunnel</StyledSubHeading>
            <StyledParagraph>
             Shadow Tunnel is a privacy infrastructure protocol designed to protect on chain activity and reduce transactional traceability across the multichain internet. By separating wallet interaction patterns from visible transaction flows, Shadow Tunnel helps preserve financial privacy, limit behavioral analysis, and strengthen anonymous value movement within the SVPN ecosystem.
            </StyledParagraph>
    <PurpleButton href='https://apps.apple.com/pk/app/shadow-tunnel-secure-trade/id6746584785' target='_blank' style={{ padding: '8px 20px', fontSize: '17px' }}>
                  Install Shadow Tunnel
                </PurpleButton>
     

          </CardContent3>
        </CardBox2>

        {/* Grid for Tunnel and Talk */}
        <Grid container spacing={4} sx={{ alignItems: 'stretch', marginTop: '2px' }}>
          {/* Shadow Tunnel */}
          <Grid item xs={12} md={6} sx={{ display: 'flex' }} >
            <EnhancedCardBox>
              <ImageContainer>
                 <CardImage1 src={bgtalk} alt="Shadow Talk" draggable='false' />
              </ImageContainer>
              <CardContent2>
                <StyledSubHeading>Shadow Talk</StyledSubHeading>
                <StyledParagraph>
                  Encrypted messaging designed for both online and offline environments. ShadowTalk introduces secure communication that remains functional even in restricted or unstable connectivity conditions, including offline value transfer capabilities.
A communication layer built for resilience.
                  {/* <br />
                  Shadow Tunnel exists for one reason:
                  <br />
                  to make privacy a property of the network, not a feature you have to trust. */}
                </StyledParagraph>

                 <UpperBox>
                  <BlackButton style={{ padding: '8px 20px', fontSize: '15px' }}>
                    Coming Soon
                  </BlackButton>
                </UpperBox>

              </CardContent2>
            </EnhancedCardBox>
          </Grid>

          {/* Shadow Talk */}
          <Grid item xs={12} md={6} sx={{ display: 'flex' }} >
            <EnhancedCardBox>
              <ImageContainer>
                <CardImage1 src={surf} alt="Shadow Talk" draggable='false' />
              </ImageContainer>
              <CardContent>
                <StyledSubHeading>ShadowSurf</StyledSubHeading>
                <StyledParagraph>
Private browsing infrastructure built for unrestricted access and secure navigation across the multichain internet.
ShadowSurf extends privacy beyond communication into full browsing environments where user activity remains protected at the network level.
              </StyledParagraph>

                <UpperBox>
                  <BlackButton style={{ padding: '8px 20px', fontSize: '15px' }}>
                    Coming Soon
                  </BlackButton>
                </UpperBox>

              </CardContent>
            </EnhancedCardBox>
          </Grid>
        </Grid>
      </Container>

      <EarthBox >
        <CardImage src={sunshine} alt="Truly Anonymous" style={{ width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 }} data-aos="fade-up" />
        <video
          autoPlay
          loop
          muted
          playsInline
          style={{ position: 'absolute', top: '-297px', left: '50%', transform: 'translateX(-50%)', width: '100%', height: '117%', zIndex: 0, maxWidth: '661px' }}>
          <source src={star} type="video/mp4" />
        </video>
        <TextBox  id='whyshadownode' >
          <Heading >
            Truly <span style={{
              background: "linear-gradient(100deg, rgb(219, 212, 233) 32%, rgb(156 90 237 / 83%)) text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontWeight: 'Bolder'
            }}>Anonymous</span>
          </Heading>

          <Paragraph style={{ marginTop: '20px' }}>
            We aim to protect each user's privacy and will strive to shield you from unwanted tracking.
          </Paragraph>
        </TextBox>
      </EarthBox>

      <BottomBox>
        <Container maxWidth='lg'>
          <Grid container spacing={6}>
            <Grid item xs={12} md={4} sm={6} >
              <AnimatedCardWrapper

                imageSrc={nologtwo}
                overlayText="Strict No-Log Policy"
              />
            </Grid>
            <Grid item xs={12} md={4} sm={6} >
              <AnimatedCardWrapper
                imageSrc={nodecard}
                overlayText={"Private\nNodes"}
              />
            </Grid>
            <Grid item xs={12} md={4} sm={6} >
              <AnimatedCardWrapper
                imageSrc={cryptopyament}
                overlayText="Crypto Payments"

              />
            </Grid>
          </Grid>
        </Container>
        <BlurOverlay />
      </BottomBox>
    </Wrapper>
  );
};

export default EcoSystem;
